<template>
  <v-card v-if="model.cve_empleado" class="elevation-2" color="grey lighten-3">
    <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <h2 class="font-weight-bold title pa-2 text-center">Adscripciones</h2>
            <DataTableMain :datatable="tableAdscripciones" :on-success='successTableAction' :itemsAction='tableAction' />
          </v-col>
          <v-col cols="4">
            <h2 class="font-weight-bold title pa-2 text-center">Foto Colaborador</h2>
            <v-card outlined tile v-if="model.FotoString">
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <div class="container-foto">
                    <v-img class="foto" :src="`data:image/png;base64,${model.FotoString}`" max-width="305" />
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="8" >
            <h2 class="font-weight-bold title pa-2 text-center">Cuentas Bancarias</h2>
            <DataTableMain :datatable="tableCuentas" :on-success='successTableAction' :itemsAction='tableAction' />
          </v-col>
          <v-col cols="6">
            <h2 class="font-weight-bold text--primary pa-2 text-center">Contactos</h2>
            <DataTableMain :datatable="tableContacto" :on-success='successTableAction' :itemsAction='successTableAction' />
          </v-col>
          <v-col cols="6">
            <h2 class="font-weight-bold text--primary pa-2 text-center">Direcciones</h2>
            <DataTableMain :datatable="tableDirecciones" :on-success='successTableAction' :itemsAction='tableAction' />
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    tableAdscripciones: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newAdscripcionData', code: 'adscripcion.execute-create' }
        ],
        titles: [
          { text: 'Empleado', value: 'empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Plaza', value: 'plaza.nombre', class: 'black--text' },
          { text: 'Tipo Plaza', value: 'plaza.tipo_plaza.nombre', class: 'black--text' },
          { text: 'Puesto', value: 'plaza.puesto.nombre', class: 'black--text' },
          { text: 'Categoia', value: 'plaza.categoria.nombre', class: 'black--text' },
          { text: 'Nivel', value: 'plaza.nivel.nivel', class: 'black--text' },
          { text: 'Zona', value: 'plaza.zona.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateAdscripcionData', code: 'nomina-adscripciones.update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    tableCuentas: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newCuentaData', code: 'rh.empleados.cuentas-store' }
        ],
        titles: [
          { text: 'NumeroCuenta', value: 'NumeroCuenta', class: 'black--text' },
          { text: 'Clave Banco', value: 'banco.clave', class: 'black--text' },
          { text: 'Nombre Banco', value: 'banco.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar Cuenta', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateCuentaData', code: 'nomina-cuentas-empleados.new' }
        ]
      },
      footer: {
        paging: true
      }
    },
    tableContacto: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newContactoData', code: 'rh.empleados.contactos-new', hidden: '' }
        ],
        titles: [
          { text: 'Contacto', value: 'contacto', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    tableDirecciones: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newDireccionData', code: 'rh.empleados.direcciones-store' }
        ],
        titles: [
          { text: 'Direccion', value: 'direccion_completa', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar Direccion', icon: 'mdi-pencil', color: 'yellow darken-3', action: 'updateDireccionData', code: 'rh.empleados.direcciones-update' }
        ]
      },
      footer: {
        paging: true
      }
    },
    itemInsumos: {}
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableAdscripciones })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableCuentas })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableDirecciones })
  },
  methods: {
    ...mapMutations([]),
    /* *==========*==========*==========*==========*==========* */
    successTableAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      this.onSuccess(item)
    },
    newContactoData (item) {
      this.onSuccess(item)
    },
    newDireccionData (item) {
      this.onSuccess(item)
    }
    /* *==========*==========*==========*==========*==========* */
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {
      if (val) {
        this.tableAdscripciones.body.data = this.model.adscripciones
        this.tableCuentas.body.data = this.model.cuentas_bancarias
        this.tableContacto.body.data = this.model.contactos
        this.tableDirecciones.body.data = this.model.direcciones
      }
    }
  }
}
</script>

<style>
.container-foto {
  position: relative
}
.foto {
  display: block;
  margin: 0 auto;
}
</style>
